var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlacktick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0682,
    cy: 12.6915,
    r: 12.1629,
    fill: "#181818"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4541 12.2237L11.1965 15.9661L18.2136 8.94907",
    stroke: "#454545",
    strokeWidth: 0.935608
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacktick);
export default __webpack_public_path__ + "static/media/blacktick.cb36679982dafc67adb03bcea5887e03.svg";
export { ForwardRef as ReactComponent };